import api from 'ApiConfig';

const userService = {
  updatePassword: async (oldPassword, newPassword, orgId) => {
    return api.post('/login/update-password/student', {
      oldPassword,
      newPassword,
      orgId,
    });
  },
  getProfilePic: async () => {
    return api.get('/student/get-profile-pic');
  },
  ProfileDetails: async () => {
    return api.get('/student/get-profile-details');
  },
};

export default userService;
